.icon {
	display: flex;
	position: relative;
	flex-shrink: 0;
	background-color: currentColor;
	height: 15px;
	width: 15px;
	z-index: 1;
	pointer-events: none;
	color: inherit;
}

.inline {
	display: inline-flex;
}
